import * as en from './en/index';

export default {
  en,
};
